import { Text } from '@rbilabs/universal-components';

import { CopyButton, PluInfo, StoreInfo } from 'components/debug-tool';
import { LoyaltyOffer, LoyaltyReward, isLoyaltyOffer } from 'state/loyalty/types';
import { blockContentToPlainText } from 'utils/sanity';

interface IIncentiveDebugProps {
  incentive: LoyaltyOffer | LoyaltyReward;
  storePosVendor: string;
}

export const IncentiveDebug: React.FC<IIncentiveDebugProps> = ({ incentive, storePosVendor }) => {
  const incentiveType = isLoyaltyOffer(incentive) ? 'Offer' : 'Reward';
  const incentiveName = isLoyaltyOffer(incentive)
    ? blockContentToPlainText(incentive.name?.localeRaw)
    : incentive.name?.locale;
  const headerText = `${incentiveType}: ${incentiveName}`;
  const loyaltyEngineId = incentive.loyaltyEngineId ?? 'Not Available';
  const vendorConfig = incentive?.vendorConfigs?.[storePosVendor];

  const [benefit] = incentive.incentives ?? [];
  const benefitVendorConfig =
    benefit && 'vendorConfigs' in benefit ? benefit?.vendorConfigs?.[storePosVendor] : null;

  return (
    <>
      <Text variant="headerOne">{headerText}</Text>
      <StoreInfo />
      <Text variant="headerTwo" marginBottom="$2">{`${incentiveType} Plu:`}</Text>
      {vendorConfig && <PluInfo vendorConfig={vendorConfig} />}
      {benefitVendorConfig && (
        <>
          <Text variant="headerTwo" marginBottom="$2">
            Benefit Plu:
          </Text>
          <PluInfo vendorConfig={benefitVendorConfig} />
        </>
      )}
      <CopyButton label={`Engine ID: ${loyaltyEngineId}`} textToCopy={loyaltyEngineId} />
    </>
  );
};
